module.exports = __webpack_public_path__ + "assets/images/magenta_sport_4.51712167341159449f1bad1218543e8d.png";